import "devextreme/dist/css/dx.common.css";
import "devextreme/dist/css/dx.light.css";
import "antd/dist/antd.css";
import React, { useEffect, useCallback } from "react";
import { Switch, BrowserRouter as Router } from "react-router-dom";
import { connect } from "react-redux";
import { authProtectedRoutes, publicRoutes } from "./routes";
import getProtectedRoutes from "./routes/routeHelper";
import AppRoute from "./routes/route";
import VerticalLayout from "./components/VerticalLayout";
import NonAuthLayout from "./components/NonAuthLayout";
import "./assets/scss/theme.scss";
import "./assets/css/devexpress.css";
import { getMemberInfo, setMemberToken, getPermissions } from "./store/actions";
import { LoadMemberProfile, LoadRegionalData } from "./helpers/storeLoadHelper";

const App = (props) => {
    const { token, dispatch, history } = props;

    const loadData = useCallback(() => {
        let authToken = token;
        if (!authToken) {
            const storedUser = localStorage.getItem("authUser");
            if (storedUser) {
                const userKey = JSON.parse(storedUser);
                authToken = userKey.key;
                dispatch(setMemberToken(authToken));
            }
        }

        if (authToken) {
            dispatch(getPermissions(authToken, history));
            dispatch(getMemberInfo(authToken, history));
            LoadMemberProfile(authToken, dispatch);
            LoadRegionalData(authToken, dispatch);
        }
    }, [token, dispatch, history]);

    useEffect(() => {
        loadData();
    }, [loadData]);

    const getLayout = () => {
        switch (props.layout.layoutType) {
            case "horizontal":
                return VerticalLayout; // Replace with HorizontalLayout if available
            default:
                return VerticalLayout;
        }
    };

    const Layout = getLayout();
    const ProtectedRoutes = getProtectedRoutes(
        authProtectedRoutes,
        props.permissions,
        props.high_division,
        props.is_patronager,
        props.is_observer,
        props.is_diaspora_coordinator,
        props.is_ftv_coordinator
    );

    return (
        <React.Fragment>
            <Router basename={process.env.REACT_APP_BASENAME || ""}>
                    <Switch>
                        {publicRoutes.map((route, idx) => (
                            <AppRoute
                                key={idx}
                                path={route.path}
                                layout={NonAuthLayout}
                                component={route.component}
                                isAuthProtected={false}
                                token={token}
                            />
                        ))}
                        {ProtectedRoutes.map((route, idx) => (
                            <AppRoute
                                key={idx}
                                path={route.path}
                                layout={Layout}
                                component={route.component}
                                isAuthProtected={true}
                                token={token}
                            />
                        ))}
                    </Switch>
            </Router>
        </React.Fragment>
    );
};

const mapStateToProps = (state) => ({
    layout: state.Layout,
    permissions: state.Permission.permissions,
    high_division: state.Member.high_division,
    is_patronager: state.Member.is_patronager,
    is_diaspora_coordinator: state.Member.is_diaspora_coordinator,
    is_ftv_coordinator: state.Member.is_ftv_coordinator,
    is_observer: state.Member.is_observer,
    token: state.Member.token,
});

export default connect(mapStateToProps)(App);
